export { default } from './NetworkService';
